export type AppEnvironment = 'development' | 'uat' | 'production';

export interface AppEnv {
  appEnv: AppEnvironment;
  /** API origin without a trailing slash. Empty string means the page's own origin. */
  apiBaseUrl: string;
}

const APP_ENVIRONMENTS: readonly string[] = ['development', 'uat', 'production'];

/** Validates raw Vite env values. Throws a readable error for a bad configuration. */
export function parseEnv(raw: { VITE_APP_ENV?: unknown; VITE_API_BASE_URL?: unknown }): AppEnv {
  const appEnvRaw = typeof raw.VITE_APP_ENV === 'string' ? raw.VITE_APP_ENV.trim() : '';
  const appEnv = appEnvRaw === '' ? 'development' : appEnvRaw;
  if (!APP_ENVIRONMENTS.includes(appEnv)) {
    throw new Error(
      `VITE_APP_ENV must be one of ${APP_ENVIRONMENTS.join(', ')} (received "${appEnvRaw}").`,
    );
  }

  const baseRaw = typeof raw.VITE_API_BASE_URL === 'string' ? raw.VITE_API_BASE_URL.trim() : '';
  const apiBaseUrl = baseRaw.replace(/\/+$/, '');
  if (apiBaseUrl !== '' && !/^https?:\/\/[^\s/]+(:\d+)?(\/[^\s]*)?$/.test(apiBaseUrl)) {
    throw new Error(
      `VITE_API_BASE_URL must be empty (same origin) or an http(s) origin (received "${baseRaw}").`,
    );
  }

  return { appEnv: appEnv as AppEnvironment, apiBaseUrl };
}

export const env: AppEnv = parseEnv(import.meta.env);
